import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import TurnYourOutdatedSiteIntoADigitalPowerhouse from "./sections/TurnYourOutdatedSiteIntoADigitalPowerhouse";
import TheLionheartedPhilosophy from "./sections/TheLionheartedPhilosophy";
import TheGrowthEcosystem from "./sections/TheGrowthEcosystem";
import TheRoadmapToScaling from "./sections/TheRoadmapToScaling";
import StartYourGrowthJourney from "./sections/StartYourGrowthJourney";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <TurnYourOutdatedSiteIntoADigitalPowerhouse />
      <TheLionheartedPhilosophy />
      <TheGrowthEcosystem />
      <TheRoadmapToScaling />
      <StartYourGrowthJourney />
      <Footer />
    </div>;
}